import type { ApiResponse, PagedResponseDto } from "@/types/common";
import type {
  PaymentFilterParams,
  PaymentListDto,
  PaymentOrderResponseDto,
  PaymentResponseDto,
  VerifyPaymentDto,
} from "@/types/payment.dto";
import { apiClient, unwrapApiResponse } from "./httpClient";

export const paymentsService = {
  createOrder(orderId: number): Promise<PaymentOrderResponseDto> {
    return unwrapApiResponse(
      apiClient.post<ApiResponse<PaymentOrderResponseDto>>(`/Payments/create-order/${orderId}`),
    );
  },

  verify(dto: VerifyPaymentDto): Promise<PaymentResponseDto> {
    return unwrapApiResponse(apiClient.post<ApiResponse<PaymentResponseDto>>("/Payments/verify", dto));
  },

  getByOrderId(orderId: number): Promise<PaymentResponseDto> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<PaymentResponseDto>>(`/Payments/order/${orderId}`),
    );
  },

  getAll(filter: PaymentFilterParams = {}): Promise<PagedResponseDto<PaymentListDto>> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<PagedResponseDto<PaymentListDto>>>("/Payments", { params: filter }),
    );
  },
};
